import React from "react"
import MySelectCreatableFormField from "@common-components/fields/MySelectCreatableFormField"
import { REGEXP_EMAIL } from "@common-constants/*"
import { CONST_API_UTILS_GET_ACTIVE_STAFF_EMAILS_ENDPOINT, CONST_API_UTILS_GET_CLIENTS_EMAILS_ENDPOINT } from "../../../../../../endpoints"

export const InterviewParticipants: React.FC<{ helpers: any }> = ({ helpers }) => {
     return (
          <div className="p-6 rounded-4 mb-10">
               <h4 className="fw-boldest text-gray-800 mb-6 d-flex align-items-center">
                    <span className="badge badge-circle badge-warning me-3 text-white">3</span> Participants
               </h4>
               <div className="row g-6">
                    <div className="col-12">
                         <MySelectCreatableFormField
                              name="organisateurs"
                              label={<span className="fw-boldest text-gray-700 fs-7 text-uppercase required">Interne (CTS)</span>}
                              formikProps={helpers}
                              isValidNewOption={val => REGEXP_EMAIL.test(val)}
                              placeholder="Ajouter les participants CTS..."
                              endpoint={CONST_API_UTILS_GET_ACTIVE_STAFF_EMAILS_ENDPOINT}
                              method="GET"
                              minimumLengthSearch={2}
                         />
                    </div>
                    <div className="col-12">
                         <MySelectCreatableFormField
                              name="autresParticipants"
                              label={<span className="fw-boldest text-gray-700 fs-7 text-uppercase required">Externe (Candidat, Client...)</span>}
                              formikProps={helpers}
                              placeholder="Email du candidat, client, partenaire..."
                              isValidNewOption={val => REGEXP_EMAIL.test(val)}
                              endpoint={helpers.values.type === "TYPE_ENTRETIEN_CLIENT" ? CONST_API_UTILS_GET_CLIENTS_EMAILS_ENDPOINT : undefined}
                              method={helpers.values.type === "TYPE_ENTRETIEN_CLIENT" ? "GET" : undefined}
                              minimumLengthSearch={2}
                         />
                    </div>
               </div>
          </div>
     )
}
